import {
  AdyenCheckout,
  CoreConfiguration,
  Dropin,
  PaymentMethodsConfiguration,
} from '@adyen/adyen-web/auto'
import '@adyen/adyen-web/styles/adyen.css'
import { IModal } from 'featureSliced/shared/store/reducers/ModalsReducer/types'

export const adyenModalId = 'ADYEN_PAYMENT_CONTAINER'

export const openAdyenModal = async (
  openModal: (modal: IModal) => void,
  configuration: CoreConfiguration,
  paymentMethodsConfig: PaymentMethodsConfiguration
) => {
  await openModal({
    id: adyenModalId,
    shouldHideCross: true,
    components: [() => <div id="dropin-container" />],
  })

  const adyenCheckout = await AdyenCheckout(configuration)

  new Dropin(adyenCheckout, {
    paymentMethodsConfiguration: paymentMethodsConfig,
  }).mount('#dropin-container')
}
